import Immutable from 'immutable';

import { ActionTypes } from './actions';

export const initialState = Immutable.fromJS({});

const setJobImportHistoryOperation = (state, { jobImportHistoryOperationData }) => {
  if (!jobImportHistoryOperationData) return state;
  return state.merge({ jobImportHistoryOperationData });
};

const setDownloadImportFileDataOperation = (state, { downloadImportfileHistoryOperationData }) => {
  if (!downloadImportfileHistoryOperationData) return state;
  return state.merge({ downloadImportfileHistoryOperationData });
};

const clearDownloadImportFileData = state => {
  return state.set('downloadImportfileHistoryOperationData', null);
};

export const callbacks = [
  {
    actionType: ActionTypes.SET_JOB_IMPORT_HISTORY_DATA,
    actionFunction: setJobImportHistoryOperation,
  },
  {
    actionType: ActionTypes.SET_DOWNLOAD_IMPORT_FILE_DATA_OPERATION,
    actionFunction: setDownloadImportFileDataOperation,
  },
  {
    actionType: ActionTypes.CLEAR_DOWNLOAD_IMPORT_FILE_DATA,
    actionFunction: clearDownloadImportFileData,
  },
];
